import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src623653266/src/portal-v2/src/client/components/page-loading.tsx");
